// src/components/CardList.js
import React, { useEffect } from "react";
import { traducciones } from "../data/aboutData";
import AboutCard from "../components/aboutCard";
import styles from "./css/about.module.css";

function AboutPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const idioma = "es"; // Cambia esto según el idioma que desees mostrar

  return (
    <div style={styles.cardList}>
      {Object.keys(traducciones).map((key) => {
        const traduccion = traducciones[key][idioma]; // Accede a la traducción según el idioma
        return traduccion ? ( // Verifica que la traducción exista
          <AboutCard
            key={traduccion.id} // Usar el id de la traducción correspondiente
            id={traduccion.id} // Pasar el id al componente
          />
        ) : null; // Si no hay traducción, no renderiza nada
      })}
    </div>
  );
}

export default AboutPage;
